import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header>
      <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
        <h1>CodeMates</h1>
      </Link>
      {/* Future navigation links can go here */}
    </header>
  );
}

export default Header; 